/* ============================================================
   GrandmaPure — theme.js
   Scroll reveals · mobile menu · header scroll · PDP logic
   ============================================================ */

(function () {
  "use strict";

  /* ── SCROLL REVEAL ──────────────────────────────────────── */
  var revealObs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          revealObs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.10, rootMargin: "0px 0px -30px 0px" }
  );

  function initReveals() {
    document.querySelectorAll(".reveal").forEach(function (el) {
      var delay = el.dataset.delay || 0;
      el.style.transitionDelay = delay + "ms";
      revealObs.observe(el);
    });
  }

  /* ── MOBILE MENU ────────────────────────────────────────── */
  function initMobileMenu() {
    var openBtn  = document.querySelector("[data-mobile-menu-open]");
    var closeBtn = document.querySelector("[data-mobile-menu-close]");
    var panel    = document.querySelector("[data-mobile-menu-panel]");
    if (!panel) return;

    function openMenu()  { panel.classList.add("is-open");    document.body.style.overflow = "hidden"; }
    function closeMenu() { panel.classList.remove("is-open"); document.body.style.overflow = ""; }

    if (openBtn)  openBtn.addEventListener("click", openMenu);
    if (closeBtn) closeBtn.addEventListener("click", closeMenu);
    panel.addEventListener("click", function (e) { if (e.target === panel) closeMenu(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && panel.classList.contains("is-open")) closeMenu();
    });
  }

  /* ── STICKY HEADER SHADOW ───────────────────────────────── */
  function initHeaderScroll() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    window.addEventListener("scroll", function () {
      header.classList.toggle("is-scrolled", window.scrollY > 10);
    }, { passive: true });
  }

  /* ── FAQ ACCORDION ──────────────────────────────────────── */
  function initFAQ() {
    var items = document.querySelectorAll("details.faq-item");
    items.forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        }
      });
    });
  }

  /* ── CART COUNT (AJAX) ──────────────────────────────────── */
  function initCartCount() {
    var counts = document.querySelectorAll(".cart-count");
    if (!counts.length) return;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        counts.forEach(function (el) {
          if (data.item_count > 0) {
            el.textContent = data.item_count;
            el.hidden = false;
          } else {
            el.hidden = true;
          }
        });
      })
      .catch(function () {});
  }

  /* ── PDP: THUMBNAIL GALLERY ─────────────────────────────── */
  function initPdpGallery() {
    var mainImg   = document.getElementById("PdpMainImg");
    var thumbWrap = document.getElementById("PdpThumbs");
    if (!mainImg || !thumbWrap) return;

    var thumbs = thumbWrap.querySelectorAll(".pdp-thumb");

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var newSrc = thumb.dataset.src;
        if (newSrc && newSrc !== mainImg.src) {
          mainImg.style.opacity    = "0";
          mainImg.style.transition = "none";
          setTimeout(function () {
            mainImg.src = newSrc;
            mainImg.style.transition = "opacity 0.3s ease";
            mainImg.style.opacity    = "1";
          }, 80);
        }
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* ── PDP: VARIANT SELECTION ─────────────────────────────── */
  function initPdpVariants() {
    var variantBtns  = document.querySelectorAll(".pdp-variant-btn");
    var variantInput = document.getElementById("PdpVariantInput");
    var priceEl      = document.getElementById("PdpPrice");
    var mobilePrice  = document.getElementById("PdpMobileBarPrice");
    var mobileVar    = document.getElementById("PdpMobileBarVariant");
    var atcBtn       = document.getElementById("PdpAtcBtn");
    var mobileAtcBtn = document.getElementById("PdpMobileAtcBtn");

    if (!variantBtns.length) return;

    variantBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;

        variantBtns.forEach(function (b) { b.classList.remove("is-selected"); });
        btn.classList.add("is-selected");

        var id        = btn.dataset.variantId;
        var price     = btn.dataset.price;
        var available = btn.dataset.available === "true";
        var titleEl   = btn.querySelector(".pdp-v-title");
        var titleText = titleEl ? titleEl.textContent.replace("· Sold out","").trim() : "";

        if (variantInput) variantInput.value = id;
        if (priceEl)      priceEl.textContent = price;
        if (mobilePrice)  mobilePrice.textContent = price;
        if (mobileVar)    mobileVar.textContent = titleText;

        var label = available ? "Add to Cart" : "Sold out";
        if (atcBtn) {
          atcBtn.disabled    = !available;
          atcBtn.textContent = label;
        }
        if (mobileAtcBtn) {
          mobileAtcBtn.disabled    = !available;
          mobileAtcBtn.textContent = label;
        }
      });
    });

    /* Mobile ATC triggers main form */
    if (mobileAtcBtn) {
      mobileAtcBtn.addEventListener("click", function () {
        var form = document.getElementById("PdpForm");
        if (!form) return;
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
    }
  }

  /* ── PDP: QUANTITY STEPPER ──────────────────────────────── */
  function initPdpQty() {
    var display = document.getElementById("PdpQtyDisplay");
    var input   = document.getElementById("PdpQtyInput");
    var btns    = document.querySelectorAll(".pdp-qty-btn");
    if (!display || !input) return;

    var qty = 1;
    btns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var delta = parseInt(btn.dataset.delta, 10);
        qty = Math.max(1, qty + delta);
        display.textContent = qty;
        input.value         = qty;
      });
    });
  }

  /* ── INIT ────────────────────────────────────────────────── */
  document.addEventListener("DOMContentLoaded", function () {
    initReveals();
    initMobileMenu();
    initHeaderScroll();
    initFAQ();
    initCartCount();
    initPdpGallery();
    initPdpVariants();
    initPdpQty();
  });

})();
